<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 选择app类型-弹出层版本
 * @Date: 2021-09-13 16:29:07
 * @LastEditTime: 2021-12-31 15:48:45
-->
<template>
  <div class="SelectStoreType">
    <van-cell is-link :title="config.name" value-class="flex align-center justify-end" @click="openBox">
      <template #value>
        <img v-if="(pageType==='order'||pageType==='keyword')&&platform&&orderForm.platform!=='no'" :src="storeImages[platform]" :alt="selectdStoreName">
        <img v-if="pageType==='app'&&storeImages[state.selectdStore]&&platform&&orderForm.platform!=='no'" :src="storeImages[state.selectdStore]" :alt="selectdStoreName">
        <span v-if="pageType==='order'||pageType==='keyword'" class="store-name ml-10">{{ orderForm.platform!=='no'?(platform?(platform===1?'Google Play':(platform===2 ? 'App Store-iPhone' : 'App Store-iPad' )):'All'):'(no app)' }}</span>
        <span v-if="pageType==='app'" class="store-name ml-10">{{ platform?(selectdStoreName?selectdStoreName:'All'):'All' }}</span>
      </template>
    </van-cell>
    <van-action-sheet v-model:show="state.show" :title="config.title" @select="openBox">
      <div v-for="(item) in state.stores" :key="item[0]" class="flex justify-center align-center pt-20 pb-20 border-top" @click="onSelect(item[1])">
        <img v-if="storeImages[item[1]]" :src="storeImages[item[1]]" :alt="item[0]">
        <span class="ml-10">{{ item[0] }}</span>
      </div>
    </van-action-sheet>
    <hr class="select-status-bottom">
  </div>
</template>

<script>
import { reactive, inject, computed ,watch} from 'vue'
import Google from 'assets/images/icon/icon-google.svg'
import Apple from 'assets/images/icon/icon-apple.svg'
import { useStore } from 'vuex'
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          title:'Select Store' , 
          name:'Store',
        }
      },
    },
    pageType: {
      type: String,
      default: ''
    },
    platform: {
      type: Number,
      default: () => null
    },
    orderType:{
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const store=useStore()
    //应用类型
    let STORETYPES ={
        'All': null,
        'Google Play': 1,
        'App Store-iPad':3,
        'App Store-iPhone':2
      }

    //store 图片
    const storeImages = {
      '0': null,
      '1': Google,
      '2': Apple,
      '3': Apple,
    }
    const common = inject('$common')
    const state = reactive({
      selectdStore: 0,
      show: false,
      stores: Object.entries(common.STORETYPES) || Object.entries(STORETYPES),
    })
    if(props.orderType==='aso'){
        STORETYPES={
          'All': null,
          '(no app)':'no',
          'Google Play': 1,
          'App Store-iPad':3,
          'App Store-iPhone':2
        }    
        state.stores=Object.entries(STORETYPES)
      }

    watch(()=>props.orderType,()=>{
      if(props.orderType==='aso'){
        STORETYPES={
          'All': null,
          '(no app)':'no',
          'Google Play': 1,
          'App Store-iPad':3,
          'App Store-iPhone':2
        }    
      }else{
        STORETYPES={
          'All': null,
          'Google Play': 1,
          'App Store-iPad':3,
          'App Store-iPhone':2
        }
      }
      state.stores=Object.entries(STORETYPES)
    })
    

    //打开选项框
    const openBox = () => {
      state.show = !state.show
    }

    const clearStoreImage=()=>{
      state.selectdStore==0
    }

    //选择应用的名称
    const selectdStoreName = computed(() => {
      let tem = null
      state.stores &&
        state.stores.forEach((item) => {
          if (item[1] === state.selectdStore) {
            tem = item[0]
            return
          }
        })
      return tem
    })
    

    //选择结果
    const onSelect = (val = null) => {
      openBox()
      state.selectdStore = val
      //暴露值
      val = val === 0 ? null : val
      if(props.pageType==='order'){
        store.commit('order/setOrderStore',val)
        //切换store时，重置app和country
        if(store.state.order.order.appId){
          store.commit('order/setOrderAppId',null)
        }
        if(store.state.order.order.region){
          store.commit('order/setOrderRegion',null)
        }
      }
      emit('selectStore', val)
      //允许store选项显示非All的值
      if(!props.platform){
        emit('cancelClearStore')
      }
    }

    const orderForm=store.state.order.order

    return {
      state,
      openBox,
      selectdStoreName,
      storeImages,
      onSelect,
      orderForm,
      clearStoreImage
    }
  },
}
</script>
<style lang="scss" scoped>
.selected {
  background: $main;
  color: white;
}

.store-name {
  font-size: 13px;
  color: #1e183f;
}

.SelectStoreType {
  .van-cell {
    padding: 8px 10px;

    &::after {
      left: 10px;
      right: 10px;
    }

    :deep(.van-cell__title) {
      color: #1e183f;
      font-weight: bold;
    }

    :deep(.van-cell__value) {
      font-size: 13px;
    }
  }

  .select-status-bottom {
    height: 0;
    border: none;
    position: absolute;
    border-top: 1px solid #ebeef5;
  }
}
</style>
